/**
 * LALEBU Category Carousel
 * Infinite slider with clone-based looping — no dependencies
 */
(function () {
  document.querySelectorAll('.lalebu-carousel').forEach(function (carousel) {
    var viewport = carousel.querySelector('.lalebu-carousel__viewport');
    var track = carousel.querySelector('.lalebu-carousel__track');
    var originalSlides = Array.from(track.children);
    var prevBtn = carousel.querySelector('.lalebu-carousel__arrow--prev');
    var nextBtn = carousel.querySelector('.lalebu-carousel__arrow--next');

    if (!originalSlides.length) return;

    var totalOriginal = originalSlides.length;
    var slidesToShow = getSlidesToShow();
    var currentIndex = 0;
    var isTransitioning = false;
    var slideWidth = 0;

    function getSlidesToShow() {
      var w = window.innerWidth;
      if (w >= 1024) return 4;
      if (w >= 768) return 3;
      if (w >= 480) return 2;
      return 1;
    }

    /* ------ Clone slides for seamless infinite loop ------ */
    function setupClones() {
      // Remove old clones
      var oldClones = track.querySelectorAll('[data-clone]');
      for (var i = 0; i < oldClones.length; i++) oldClones[i].remove();

      var n = slidesToShow; // number of clones each side

      // Append clones of the first N slides at the end
      for (var i = 0; i < n; i++) {
        var idx = i % totalOriginal;
        var clone = originalSlides[idx].cloneNode(true);
        clone.setAttribute('data-clone', 'end');
        track.appendChild(clone);
      }

      // Prepend clones of the last N slides at the start
      for (var i = n; i > 0; i--) {
        var idx = (totalOriginal - i % totalOriginal) % totalOriginal;
        var clone = originalSlides[idx].cloneNode(true);
        clone.setAttribute('data-clone', 'start');
        track.insertBefore(clone, track.firstChild);
      }
    }

    function getAllSlides() {
      return Array.from(track.children);
    }

    /* ------ Position ------ */
    function setPosition(animate) {
      // currentIndex 0 = first real slide, which is at DOM position slidesToShow (because of prepended clones)
      var offset = (currentIndex + slidesToShow) * slideWidth;
      track.style.transition = animate
        ? 'transform 500ms cubic-bezier(0.25, 0.1, 0.25, 1)'
        : 'none';
      track.style.transform = 'translateX(-' + offset + 'px)';
    }

    function goTo(index, animate) {
      if (isTransitioning) return;
      currentIndex = index;
      if (animate) isTransitioning = true;
      setPosition(animate);
    }

    /* After transition, silently jump from clone zone to real zone */
    track.addEventListener('transitionend', function () {
      isTransitioning = false;
      if (currentIndex >= totalOriginal) {
        currentIndex = currentIndex - totalOriginal;
        setPosition(false);
      } else if (currentIndex < 0) {
        currentIndex = totalOriginal + currentIndex;
        setPosition(false);
      }
    });

    prevBtn.addEventListener('click', function () {
      goTo(currentIndex - 1, true);
    });
    nextBtn.addEventListener('click', function () {
      goTo(currentIndex + 1, true);
    });

    /* ------ Touch / swipe ------ */
    var startX = 0, startY = 0, deltaX = 0, isSwiping = false;

    track.addEventListener('touchstart', function (e) {
      if (isTransitioning) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      deltaX = 0;
      isSwiping = false;
      track.style.transition = 'none';
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if (!isSwiping && (Math.abs(dx) > 5 || Math.abs(dy) > 5)) {
        isSwiping = Math.abs(dx) > Math.abs(dy);
      }
      if (!isSwiping) return;
      e.preventDefault();
      deltaX = dx;
      var baseOffset = (currentIndex + slidesToShow) * slideWidth;
      track.style.transform = 'translateX(' + (-baseOffset + deltaX) + 'px)';
    }, { passive: false });

    track.addEventListener('touchend', function () {
      if (!isSwiping) return;
      var threshold = slideWidth * 0.25;
      if (deltaX < -threshold) {
        goTo(currentIndex + 1, true);
      } else if (deltaX > threshold) {
        goTo(currentIndex - 1, true);
      } else {
        setPosition(true);
      }
    }, { passive: true });

    /* ------ Sizing ------ */
    function setSizes() {
      var newShow = getSlidesToShow();
      if (newShow !== slidesToShow) {
        slidesToShow = newShow;
        setupClones();
      }
      slideWidth = viewport.offsetWidth / slidesToShow;
      var allSlides = getAllSlides();
      for (var i = 0; i < allSlides.length; i++) {
        allSlides[i].style.width = slideWidth + 'px';
        allSlides[i].style.flexBasis = slideWidth + 'px';
        allSlides[i].style.flexShrink = '0';
      }
      if (currentIndex >= totalOriginal) currentIndex = 0;
      setPosition(false);
    }

    // Init
    setupClones();
    setSizes();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(setSizes, 150);
    });
  });
})();
